<div class="spinner-wrapper">
  <div class="spinner">
    <img src="../assets/images/spinner.svg" alt="Spinner" />
  </div>
</div>
